import { DesignTokens, GivelifyPaper } from '@givelify/ui';
import { styled } from '@mui/material';

export const DonationDetailsContainer = styled(GivelifyPaper, {
    shouldForwardProp: (prop) => prop !== 'isRefund',
})<{ isRefund?: boolean }>(({ theme, isRefund }) => ({
    display: 'grid',
    rowGap: 24,
    gridTemplateColumns: isRefund ? 'repeat(6, auto)' : 'repeat(5,auto)',
    [theme.breakpoints.down('mobile')]: {
        gridTemplateColumns: 'repeat(4, auto)',
    },
    '& > *': {
        textAlign: 'right',
    },
    padding: '24px 12px',
    backgroundColor: DesignTokens.color.globalNeutral50,

    '& .mobileFirstRowHeader': {
        [theme.breakpoints.down('mobile')]: {
            gridColumn: isRefund ? 'span 2' : 'span 4',
            textAlign: 'left',
        },
    },

    '& .tableHeaderText': {
        fontSize: 12,
    },

    '& .donationDetailsHeader': {
        textAlign: 'left !important' as 'left',
    },

    '& .envelopeNameHeader': {
        textAlign: isRefund ? 'right' : ('left !important' as 'left'),
    },

    '& .donationDetailsText': {
        textAlign: 'left !important' as 'left',
    },

    '& .envelopeNameText': {
        gridColumn: isRefund ? 3 : 2,
        textAlign: isRefund ? 'right' : ('left !important' as 'left'),
        [theme.breakpoints.down('mobile')]: {
            gridColumn: 1,
            textAlign: 'left !important' as 'left',
        },
    },

    '& .totalBorder': {
        height: 1,
        gridColumn: '1 / -1',
        background: DesignTokens.color.chartGrey200,
    },

    '& .donationResult': {
        gridColumn: isRefund ? 4 : 3,
        [theme.breakpoints.down('mobile')]: {
            gridColumn: 2,
        },
    },

    '& .feesResult': {
        gridColumn: isRefund ? 5 : 4,
        [theme.breakpoints.down('mobile')]: {
            gridColumn: 3,
        },
    },

    '& .refundAmountResult': {
        gridColumn: isRefund ? 6 : 5,
        [theme.breakpoints.down('mobile')]: {
            gridColumn: 4,
        },
    },
    '& .mobileFirstRowText': {
        [theme.breakpoints.down('mobile')]: {
            gridRow: 2,
            gridColumn: isRefund ? 'span 2' : 'span 4',
            textAlign: 'left',
        },
    },
}));
